import { PaginatedData } from 'models/PaginatedData';
import {
  AutomationResponseBody,
  DataRoom,
  DataRoomSheet,
} from 'router/subrouters/DataRoom/models/DataRoom';
import httpClient from '../../httpClient';
import { AxiosRequestConfig } from 'axios';
import { createFileFormData } from 'uploadFileUtils';

function requestAccess(dataRoomId: string) {
  return httpClient.post<PaginatedData<DataRoom>>(
    `data-rooms/${dataRoomId}/request-access`,
  );
}

function undoRequestAccess(dataRoomId: string) {
  return httpClient.post<PaginatedData<DataRoom>>(
    `data-rooms/${dataRoomId}/undo-request-access`,
  );
}

function uploadSheet(
  file: File,
  fileName: string,
  config?: AxiosRequestConfig,
) {
  const formData = createFileFormData(fileName, file);

  return httpClient.post<DataRoomSheet[]>(
    'data-rooms/file-sheet-upload',
    formData,
    config,
  );
}

function getSheetTemplate() {
  return httpClient.get<string>('data-rooms/sheet-template');
}

function bulkCreateDataRoom(
  enterpriseId: string,
  dataRooms: Partial<DataRoomSheet>[],
) {
  return httpClient.post(`data-rooms/enterprises/${enterpriseId}/bulk-create`, {
    dataRooms,
  });
}

function automationResponse(dataRoomId: string, data?: AutomationResponseBody) {
  return httpClient.post(`data-rooms/${dataRoomId}/automation-response`, data);
}

export default {
  requestAccess,
  undoRequestAccess,
  uploadSheet,
  getSheetTemplate,
  bulkCreateDataRoom,
  automationResponse,
};
